import React from "react";
import { Button } from "react-bootstrap";

const TabsFooter = ({ setView, tabs, view }) => {
  return (
    <div className="tab-footer">
      <div className="tab-footer">
        <Button
          variant="primary previous"
          onClick={() =>
            setView(tabs?.filter((itm) => itm?.idx === view?.idx - 1)[0])
          }
          style={{
            visibility: view.idx === 0 ? "hidden" : "visible",
          }}
          // disabled={view.idx === 0}
        >
          PREVIOUS
        </Button>

        {view.idx === tabs.length - 1 ? (
          <Button
            variant="primary next"
            // onClick={() =>
            //   // setView(tabs?.find((itm) => itm?.idx === view?.idx + 1))
            // }
          >
            SAVE
          </Button>
        ) : (
          <Button
            variant="primary next"
            onClick={() =>
              setView(tabs?.find((itm) => itm?.idx === view?.idx + 1))
            }
          >
            NEXT
          </Button>
        )}
      </div>
    </div>
  );
};

export default TabsFooter;
